<template>
  <div>
    <Snackbar :SnackBarComponent="SnackBarComponent" />
    <v-dialog
      v-model="FavouriteViolation"
      persistent
      max-width="1000px"
      transition="dialog-top-transition"
      content-class="DialogOpenFromTop"
      class="DialogAlign"
    >
      <v-card>
        <v-toolbar dark dense class="elevation-0" color="gradient-bg">
          <div class="white--text">Favourite Violations</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogFavouriteViolationEmit(1)"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="text-center pb-0 mt-4">
          <!-- <v-form ref="form">
            <v-autocomplete
              dense
              outlined
              multiple
              label="Select Violation"
              class="borderRadius field_height field_label_size fontsize12px"
              v-model="violation_id"
              :items="GetAllViolationsList"
              item-text="violation_name"
              item-value="violation_id"
              return-object
            >
            </v-autocomplete>
          </v-form> -->
          <v-data-table
            dense
            :height="height"
            :headers="headers"
            :items="GetAllViolationsList"
            v-model="SelectedViolation"
            show-select
            fixed-header
            hide-default-footer
            checkbox-color="primary"
            item-key="violation_id"
            :items-per-page="100"
            :loading="loading"
            loading-text="Loading Violations"
          ></v-data-table>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            small
            class="borderRadius text-capitalize"
            color="primary"
            outlined
            @click="dialogFavouriteViolationEmit(1)"
            ><v-icon small class="mr-1">mdi-close</v-icon>Cancel</v-btn
          >
          <v-btn
            small
            class="borderRadius text-capitalize mr-2"
            color="primary"
            :loading="SubmitLoading"
            @click="validateMethod()"
            ><v-icon small class="mr-1">mdi-star</v-icon>Add To Favourite</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { favouriteViolations } from "@/graphql/mutations.js";
import { API, graphqlOperation } from "aws-amplify";

import { GetAllViolations } from "@/mixins/GetAllViolations.js";
import Snackbar from "@/components/Extras/Snackbar.vue";

export default {
  props: {
    FavouriteViolation: Boolean,
    StoreObj: Object,
  },
  components: {
    Snackbar,
  },
  mixins: [GetAllViolations],
  data: () => ({
    count: 3,
    Toggle: 0,
    height: 0,
    logoutInterval: -1,

    violation_id: "",

    loading: false,
    SubmitLoading: false,
    ViolationSent: false,
    Acknowledged: false,
    SnackBarComponent: {},
    SelectedViolation: [],
    headers: [
      {
        text: "Violation",
        value: "violation_name",
        align: "center",
      },
    ],
    ViolationArray: [],
  }),
  watch: {
    FavouriteViolation(val) {
      if (val == true) {
        this.GetAllViolationsMethod();
        // setTimeout(() => {
        //   if (
        //     this.$store.getters.get_current_user_details.favourite_violations
        //   ) {
        //     this.SelectedViolation =
        //       this.$store.getters.get_current_user_details.favourite_violations.filter(
        //         (item) =>
        //           this.GetAllViolationsList.some(
        //             (list) => list.violation_id === item.violation_id
        //           )
        //       );
        //   }
        // }, 3000);
      }
    },
  },
  mounted() {
    this.height = window.innerHeight - 190;
  },
  methods: {
    validateMethod() {
      //   if (this.$refs.form.validate()) {
      this.initiateViolationMethod();
      //   }
    },
    async initiateViolationMethod() {
      let inputParams = {
        user_id: this.$store.getters.get_current_user_details.user_id,
        favourite_violations: JSON.stringify(this.SelectedViolation),
      };
      try {
        this.SubmitLoading = true;
        let result = await API.graphql(
          graphqlOperation(favouriteViolations, {
            input: inputParams,
          })
        );
        console.log("result", result);
        var ResultObject = JSON.parse(result.data.favouriteViolations);
        if (ResultObject.status == 200) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: ResultObject.status_message,
          };
        }
        this.dialogFavouriteViolationEmit(2);
        this.SubmitLoading = false;
      } catch (error) {
        this.SubmitLoading = false;
        console.log("error", error);
      }
    },
    dialogFavouriteViolationEmit(Toggle) {
      this.$emit("clicked", Toggle);
      this.GetAllViolationsList = [];
      this.SelectedViolation = [];
    },
  },
};
</script>

<style scoped>
.gradient-bg {
  background: -webkit-linear-gradient(145deg, #590e9b 0%, #6e1c9a 100%);
  background: -moz-linear-gradient(145deg, #590e9b 0%, #6e1c9a 100%);
  background: -o-linear-gradient(145deg, #590e9b 0%, #6e1c9a 100%);
  background: -ms-linear-gradient(145deg, #590e9b 0%, #6e1c9a 100%);
  background: linear-gradient(145deg, #590e9b 0%, #6e1c9a 100%);
}
</style>
